<template>
  <AdminAlert>
      <p class="mb-2">This <b>{{ entityType }}</b> was created by<b>{{ creatorIsNotOwner ? ' ' + creatorFullName : '' }}</b>{{ creatorIsNotOwner ? ' for' : '' }}:</p>
      <CButton
        v-if="owner" 
        color="info"
        variant="outline"
        class="m-0 p-1 pl-2 pr-2 mr-2" 
        @click="setOnBehalfOfUser(owner.guid)"
      >
        <strong>{{ ownerFullName }}</strong>
      </CButton>     
  </AdminAlert>
</template>

<script>
import userAPI from '@/api/user'
import AdminAlert from '@/views/components/AdminAlert'

export default {
  name: 'AdminOwner',
  components: {
    AdminAlert
  },
  props: {
    entity: Object,
    entityType: String
  },
  data () {
    return {
    }
  },
  computed: {
    creator () {
      return this.entity?.creator || this.entity?.owner
    },
    creatorFullName () {
      return this.creator.firstName + ' ' + this.creator.lastName
    },
    creatorIsNotOwner () {
      return this.creator?.guid !== this.owner?.guid
    },
    owner () {
      return this.entity?.owner
    },
    ownerFullName () {
      return this.owner.firstName + ' ' + this.owner.lastName
    },
  },
  methods: {
    async setOnBehalfOfUser (guid) {
      try {
        const user = await userAPI.getUser(guid)
        await this.$store.dispatch('organisation/setOnBehalfOfUser', user)
        window.scrollTo(0,0)     
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>